export default class Recommendation {
  constructor(
    id: number,
    name: string,
    position: string,
    imageUrl: string,
    recommendation: string
  ) {
    this.id = id;
    this.name = name;
    this.position = position;
    this.imageUrl = imageUrl;
    this.recommendation = recommendation;
  }

  public id: number;
  public name: string;
  public position: string;
  public imageUrl: string;
  public recommendation: string;
}
